import { TextUtilities } from '@pwc/pwc-deals-web-common';

// some titles are restricted to being used, because they are used in Report Builder an
const titlesOnBlackList = [
  'introduction',
  'project overview',
  'key focus areas',
  'executive report',
  'appendix',
  'cover',
  'contents',
  'appendix content',
  'divider',
  'key focus areas: summary',
  'selected information',
  'appendices',
];

export const restrictedErrorMessage =
  'This title is used in the Report Builder. Please enter a different title.';

export const isTitleRestricted = (title) =>
  titlesOnBlackList.includes(TextUtilities.trimText(title).toLowerCase());
